import React, { Suspense } from "react";
import { Route, Routes } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ErrorPage from "./Component/ForgotPassword/ErrorPage";
import SessionTimeoutWatcher from "./Component/CommonFunctionality/SessionTimeoutWatcher";
import ProtectedRoute from "./Component/ProtectedRoute";
import appRoutes from "./routes";

const publicRoutes = appRoutes.filter((route) => !route.protected);
const protectedRoutes = appRoutes.filter((route) => route.protected);

function App() {
  return (
    <>
      <Suspense fallback={null}>
        <Routes>
          {publicRoutes.map(({ path, element }) => (
            <Route key={path} path={path} element={element} />
          ))}
          <Route element={<ProtectedRoute />}>
            {protectedRoutes.map(({ path, element }) => (
              <Route key={path} path={path} element={element} />
            ))}
          </Route>
          <Route path="*" element={<ErrorPage />} />
        </Routes>
      </Suspense>

      <SessionTimeoutWatcher />

      <ToastContainer
        position="top-right"
        autoClose={3500}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        pauseOnHover
        draggable
        limit={3}
        theme="light"
        toastClassName="ksdpl-toast"
        bodyClassName="ksdpl-toast-body"
        progressClassName="ksdpl-toast-progress"
      />
    </>
  );
}

export default App;
